import styled from 'styled-components';
import { ICON_QUESTION_GRAY } from '@repo/assets';

type Props = {
  onClick: (e: any) => void;
};

export const BankCallGuideButton = ({ onClick }: Props) => {
  return (
    <BankInquiryGuide id='guideButton' type='button' onClick={onClick}>
      <QuestionIcon id='guideButton' src={ICON_QUESTION_GRAY} alt='' />
      How do I respond to bank inquiries?
    </BankInquiryGuide>
  );
};

const BankInquiryGuide = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
  color: #5f6165;
  text-align: left;
  text-decoration: underline;
  font-size: 14px;
  width: 100%;
  margin-top: 28px;
  margin-bottom: 16px;
`;

const QuestionIcon = styled.img`
  width: 18px;
  height: 18px;
`;
